import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys } from '../react-query.config';

export interface Winner {
  userId: string;
  username: string;
  selectionId: string;
  createdAt: string | null;
}

export interface PeriodResult {
  periodCode: string;
  rowTeamScore: number | null;
  colTeamScore: number | null;
  rowLastDigit: number;
  colLastDigit: number;
  winningRowIndex: number;
  winningColIndex: number;
  winningSquareNumber: number;
  winningOptionId: string | null;
  winners: Winner[];
  computedAtUtc: string | null;
}

export interface GetPeriodResultsResponse {
  questionId: string;
  periodResults: PeriodResult[];
  totalPeriods: number;
}

export async function getPeriodResults(squareId: string): Promise<GetPeriodResultsResponse> {
  const response = await (apiClient as any).get(`/api/admin/squares/${squareId}/period-results`);
  return response as GetPeriodResultsResponse;
}

export function useGetPeriodResultsQuery(squareId: string | null) {
  return useQuery<GetPeriodResultsResponse>({
    queryKey: queryKeys.squares.periodResults(squareId),
    queryFn: () => getPeriodResults(squareId!),
    enabled: !!squareId,
  });
}
